function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 20",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.6 4a1.2 1.2 0 000 2.4h6.703l-1.552 1.552a1.2 1.2 0 001.697 1.696l3.6-3.6a1.2 1.2 0 000-1.696l-3.6-3.6a1.2 1.2 0 10-1.697 1.696L13.303 4H6.6zm4.8 12a1.2 1.2 0 100-2.4H4.697l1.551-1.552a1.2 1.2 0 10-1.697-1.696l-3.6 3.6a1.2 1.2 0 000 1.696l3.6 3.6a1.2 1.2 0 001.697-1.696L4.697 16H11.4z"
}));